import React from 'react'

const MerchScreen = () => {
  return (
    <div>MerchScreen</div>
  )
}

export default MerchScreen